export const SET_DAY_RANGE = "SET_DAY_RANGE";
export const SET_SELECTED_DAYS = "SET_SELECTED_DAYS";
export const SET_TRACKS = "SET_TRACKS";
export const SET_TRACK_ROW = "SET_TRACK_ROW";
export const OPEN_ADD_EVENT_MODAL = "OPEN_ADD_EVENT_MODAL";
export const CLOSE_ADD_EVENT_MODAL = "CLOSE_ADD_EVENT_MODAL";
export const SET_DOUBLE_CLICKED_TIMEBLOCK = "SET_DOUBLE_CLICKED_TIMEBLOCK";
export const CREATE_TASK = "CREATE_TASK";
export const CREATE_PARENT_TRACK = "CREATE_PARENT_TRACK";
export const CREATE_CHILD_TRACK = "CREATE_CHILD_TRACK";
export const OPEN_EDIT_EVENT_MODAL = "OPEN_EDIT_EVENT_MODAL";
export const CLOSE_EDIT_EVENT_MODAL = "CLOSE_EDIT_EVENT_MODAL";
export const OPEN_DELETE_TRACK_MODAL = "OPEN_DELETE_TRACK_MODAL";
export const CLOSE_DELETE_TRACK_MODAL = "CLOSE_DELETE_TRACK_MODAL";
export const OPEN_ADD_PARENT_TRACK_MODAL = "OPEN_ADD_PARENT_TRACK_MODAL";
export const CLOSE_ADD_PARENT_TRACK_MODAL = "CLOSE_ADD_PARENT_TRACK_MODAL";
export const OPEN_ADD_CHILD_TRACK_MODAL = "OPEN_ADD_CHILD_TRACK_MODAL";
export const CLOSE_ADD_CHILD_TRACK_MODAL = "CLOSE_ADD_CHILD_TRACK_MODAL";
export const DELETE_TASK = "DELETE_TASK";
export const DELETE_TRACK = "DELETE_TRACK";
export const EDIT_TRACK = "EDIT_TRACK";
export const SET_DELETING_TRACK = "SET_DELETING_TRACK";
export const SET_EDITING_TRACK = "SET_EDITING_TRACK";
export const SET_CREATE_CHILD_TRACK_PARENT = "SET_CREATE_CHILD_TRACK_PARENT";
export const OPEN_EDIT_TRACK_MODAL = "OPEN_EDIT_TRACK_MODAL";
export const CLOSE_EDIT_TRACK_MODAL = "CLOSE_EDIT_TRACK_MODAL";
export const GET_JOB_PACKS = "GET_JOB_PACKS";
export const GET_MACHINES = "GET_MACHINES";
export const GET_EQUIPMENT = "GET_EQUIPMENT";
export const GET_USERS = "GET_USERS";
export const SET_FOCUSSED_EVENT = "SET_FOCUSSED_EVENT";
export const SET_FOCUSSED_EVENT_INDICES = "SET_FOCUSSED_EVENT_INDICES";
export const EDIT_EVENT = "EDIT_EVENT";
export const SET_CLICKED_TIME_BLOCK = "SET_CLICKED_TIME_BLOCK";
export const SET_AGENDA_ITEM_DRAGGING = "SET_AGENDA_ITEM_DRAGGING";
export const SET_AGENDA_ITEM_POSITION = "SET_AGENDA_ITEM_POSITION";
export const SET_WEEK_COUNT = "SET_WEEK_COUNT";
export const SET_TRACK_HEIGHT = "SET_TRACK_HEIGHT";
export const GET_UI_STATE = "GET_UI_STATE";
export const SET_UI_STATE = "SET_UI_STATE";
export const SET_PARENT_TRACK_OPEN = "SET_PARENT_TRACK_OPEN";
